import React from "react";
import LandingAbout from "../Components/LandingAbout/LandingAbout";
const About = () => {
  return (
    <div>
      <LandingAbout />
    </div>
  );
};

export default About;
